import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
function NoOptionsMessage(props) {
   return (
      <Typography
         variant="body1"
         color="textSecondary"
         className={props.selectProps.classes.noOptionsMessage}
         {...props.innerProps}
      >
         {props.children}
      </Typography>
   );
}

NoOptionsMessage.propTypes = {
   /**
    * The children to be rendered.
    */
   children: PropTypes.node,
   /**
    * Props to be passed on to the wrapper.
    */
   innerProps: PropTypes.object,
   selectProps: PropTypes.object.isRequired
};

export default NoOptionsMessage;
